import styled from 'styled-components';
import DeleteModal from '../../../DeleteModal';

const StyledBillsTabs = styled.div`
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  position: relative;

  .ant-tabs-tabpane {
    & > div {
      padding: 0;
    }
  }
`;

const StyledBillsTabsDeleteModal = styled(DeleteModal)`
  .ant-modal-body {
    p {
      max-width: 300px;
    }
  }
`;

export {
  StyledBillsTabs,
  StyledBillsTabsDeleteModal,
}
